module.exports = __webpack_public_path__ + "img/burger.9128898d.svg";